import { keepPreviousData, useQuery } from '@tanstack/react-query';
import globalSearchApi, {
  GLOBAL_SEARCH_MIN_TERM_LENGTH,
} from '@/features/dashboard/globalSearch/api/globalSearchApi.ts';
import { globalSearchApiQueryKeys } from '@/features/dashboard/globalSearch/api/globalSearchApi.queryKeys.ts';

export const isSearchableTerm = (term: string) =>
  term.trim().length >= GLOBAL_SEARCH_MIN_TERM_LENGTH;

/**
 * Poprzednie wyniki zostają na ekranie do czasu nowych — lista nie miga przy
 * każdej literze.
 */
const useGlobalSearch = (term: string, includeCancelled: boolean) => {
  const normalized = term.trim();

  return useQuery({
    queryKey: globalSearchApiQueryKeys.byTerm(normalized, includeCancelled),
    queryFn: () => globalSearchApi.search(normalized, includeCancelled),
    enabled: isSearchableTerm(normalized),
    placeholderData: keepPreviousData,
    staleTime: 1000 * 30,
  });
};

export default useGlobalSearch;
